import { Box } from "@mui/material";
import { ErrorBoundary } from "@sentry/react";
import { useEffect } from "react";
import { EMPTY_SX } from "../../../utils/empty-sx";

import type { BoxProps } from "@mui/material";
import type { FC } from "react";

interface PageProps extends Omit<BoxProps, "title"> {
  title: string | null;
}

export const Page: FC<PageProps> = ({ children, title, sx = EMPTY_SX, ...props }) => {
  useEffect(() => {
    document.title = title || "ChangeEngine";
  }, [title]);

  return (
    <Box
      // Composed, not spread over: a caller passing sx used to drop these outright.
      sx={[
        (theme) => ({
          "--page-px": `min(min(${theme.spacing(10)}, 5vw), 10vw)`,
          overflow: "auto",
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    >
      <ErrorBoundary
        fallback={
          <Box>
            There was an error rendering this page. If the issue persists, please contact customer
            support.
          </Box>
        }
      >
        {children}
      </ErrorBoundary>
    </Box>
  );
};
